(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.transparentHeaderOverBanner =
        this.getAttribute('data-transparent-header-over-banner') === 'true';

      this.mobileBannerBehindAnnouncement =
        this.getAttribute('data-mobile-banner-behind-announcement') === 'true';

      if (this.mobileBannerBehindAnnouncement) {
        this.announcementBar = document.querySelector('.announcement-bar-section');
        this.updateAnnouncementBarHeight = this.updateAnnouncementBarHeight.bind(this);
        window.addEventListener('resize', this.updateAnnouncementBarHeight);

        if (this.announcementBar && 'ResizeObserver' in window) {
          this.announcementBarResizeObserver = new ResizeObserver(this.updateAnnouncementBarHeight);
          this.announcementBarResizeObserver.observe(this.announcementBar);
        }

        requestAnimationFrame(this.updateAnnouncementBarHeight);
      }

      if (this.transparentHeaderOverBanner) {
        this.bannerSection =
          document.querySelector('#MainContent > .shopify-section:first-child') ||
          document.querySelector('main .shopify-section:first-child');

        this.updateTransparentHeaderState = this.updateTransparentHeaderState.bind(this);
        window.addEventListener('resize', this.updateTransparentHeaderState);
        requestAnimationFrame(this.updateTransparentHeaderState);
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);

      if (this.updateTransparentHeaderState) {
        window.removeEventListener('resize', this.updateTransparentHeaderState);
      }

      if (this.updateAnnouncementBarHeight) {
        window.removeEventListener('resize', this.updateAnnouncementBarHeight);
      }

      if (this.announcementBarResizeObserver) {
        this.announcementBarResizeObserver.disconnect();
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    updateAnnouncementBarHeight() {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const announcementHeight =
        isMobile && this.mobileBannerBehindAnnouncement && this.announcementBar
          ? this.announcementBar.offsetHeight
          : 0;

      document.documentElement.style.setProperty(
        '--announcement-bar-height',
        `${announcementHeight}px`
      );
    }

    updateTransparentHeaderState() {
      if (!this.transparentHeaderOverBanner || !this.bannerSection) return;

      const bannerBottom = this.bannerSection.getBoundingClientRect().bottom;
      const headerHeight = this.header?.offsetHeight || 0;
      const announcementHeight =
        window.matchMedia('(max-width: 749px)').matches &&
        this.mobileBannerBehindAnnouncement &&
        this.announcementBar
          ? this.announcementBar.offsetHeight
          : 0;

      this.header.classList.toggle(
        'header-overlay-ended',
        bannerBottom <= headerHeight + announcementHeight
      );
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.transparentHeaderOverBanner) {
        this.updateTransparentHeaderState();
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
